import React, { useState } from "react";
import { ArtistDto } from "models/ArtistDto";
import { ApiService } from "services/ApiService";

const SimpleArtist: React.FC = () => {
    const [artist, setArtist] = useState<ArtistDto>({
        id: "",
        firstName: "",
        lastName: "",
        email: "",
        instagramUsername: "",
        isSignedUp: false,
        biography: "",
        userName: "",
        inkVoydUrl: "",
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setArtist((prevArtist) => ({
            ...prevArtist,
            [name]: value,
        }));
    };

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, checked } = e.target;
        setArtist((prevArtist) => ({
            ...prevArtist,
            [name]: checked,
        }));
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        console.log("Submitted artist data:", artist);
        
        try {
            const response = await ApiService.createSimpleArtist(artist);
            if (response.success) {
                alert("Artist data submitted successfully!");
            }
        } catch (error) {
            console.error("Error submitting artist data:", error);
            alert("Error submitting artist data. Please try again.");
        }
    };

    return (
        <form onSubmit={handleSubmit} className="max-w-md mx-auto bg-white p-6 rounded-lg shadow-md space-y-4">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">Artist Form</h2>

            <div>
                <label htmlFor="firstName" className="block text-sm font-medium text-gray-700">
                    First Name
                </label>
                <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={artist.firstName}
                    onChange={handleChange}
                    className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
                />
            </div>

            <div>
                <label htmlFor="lastName" className="block text-sm font-medium text-gray-700">
                    Last Name
                </label>
                <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={artist.lastName}
                    onChange={handleChange}
                    className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
                />
            </div>

            <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                    Email
                </label>
                <input
                    type="email"
                    id="email"
                    name="email"
                    value={artist.email}
                    onChange={handleChange}
                    className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
                />
            </div>

            <div>
                <label htmlFor="instagramUsername" className="block text-sm font-medium text-gray-700">
                    Instagram Username
                </label>
                <input
                    type="text"
                    id="instagramUsername"
                    name="instagramUsername"
                    value={artist.instagramUsername}
                    onChange={handleChange}
                    className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
                />
            </div>

            <div className="flex items-center">
                <input
                    type="checkbox"
                    id="isSignedUp"
                    name="isSignedUp"
                    checked={artist.isSignedUp}
                    onChange={handleCheckboxChange}
                    className="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500"
                />
                <label htmlFor="isSignedUp" className="ml-2 block text-sm text-gray-700">
                    Is Signed Up
                </label>
            </div>

            <button
                type="submit"
                className="w-full bg-indigo-600 text-white py-2 px-4 rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
            >
                Submit
            </button>
        </form>
    );
};

export default SimpleArtist;